import messyImg from '@assets/svg/messy.svg'
import { Button, onSocialNetworkConnection } from '@hub/shared'
import { useTranslation } from 'react-i18next'
import './empty-mediakit.component.scoped.scss'

export default () => {
  const [t] = useTranslation('emptyLinkedInstagram')
  let img = <img src={messyImg} className="img-fluid" alt="Messy-Icon" title="Messy Image" />

  return (
    <div className="linked-instagram">
      <div className="linked-div">
        <h4 dangerouslySetInnerHTML={{ __html: t('title') }} />
        <figure>{img}</figure>
        <p dangerouslySetInnerHTML={{ __html: t('text') }} />
        <Button
          style={{ maxWidth: '250px' }}
          width="100%"
          onClick={() =>
            onSocialNetworkConnection.next({
              socialNetwork: 'facebook',
              connect: true,
            })
          }
          color="var(--primary_color)"
          borderColor="var(--primary_color)"
          textColor="var(--secondary_color)"
          size="sm"
        >
          <i className="mr-1 fa-regular fa-link"></i>
          {t('button')}
        </Button>
      </div>
    </div>
  )
}
